'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _iBem = require('../../i-bem/i-bem.react');

exports.default = (0, _iBem.declMod)({ type: 'radiocheck' }, {
    block: 'select2',
    _onMenuClick: function _onMenuClick(e, val) {
        var next = val === this.state.val[0] ? [] : [val];
        this.setState({ val: next, opened: false });
        this._onChange(next);
    }
});